import {
  useState, useCallback, memo,
} from 'react';
import {
  Form, Button, message,
} from 'antd';
import request from '@api';
import { useAuthContext } from '@hooks/useAuthContext';
import classes from './index.module.css';
import AccountContact from './AccountContact';
// import { mockQuerySettings, mockUpdateSettings } from './Mock';
import { FullpageLoading } from '../../components';
import { useEffectOnce } from '../../hooks';
import EmailReset from './EmailReset';

function AccountSettings() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const { onboarding: { email } = {}, updateUser } = useAuthContext();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { code, data } = await request('account-settings');
      // const { code, data } = mockQuerySettings;
      if (code === 0) {
        form.setFieldsValue(data);
      }
    } catch (e) {
      console.log(e);
      // setLoading(false);
    }
    setLoading(false);
  });

  const handleSave = async () => {
    try {
      const { code } = await request('account-settings', {
        method: 'POST',
        body: form.getFieldsValue(),
      });
      // const { code, data } = mockUpdateSettings;
      if (code === 0) {
        message.success('Your changes have been saved.');
        setDisabled(true);
        updateUser();
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  useEffectOnce(() => {
    fetchData();
  }, []);

  if (loading) return <FullpageLoading mask />;

  return (
    <Form
      name="account-settings"
      layout="vertical"
      form={form}
      onValuesChange={() => {
        setDisabled(false);
      }}
      onFinish={handleSave}
      onFinishFailed={() => setDisabled(true)}
      initialValues={{ email }}
    >

      <div className={classes.company_panel}>
        <div className={classes.company_title}>Details</div>
        <AccountContact />
      </div>
      <div className={classes.company_panel}>
        <div className={classes.company_title}>Password</div>
        <EmailReset />
      </div>

      <Form.Item
        shouldUpdate
      >
        <Button
          type="primary"
          htmlType="submit"
          // onClick={handleSave}
          loading={loading}
          disabled={disabled}
        >
          Save
        </Button>

      </Form.Item>
    </Form>
  );
}

// eslint-disable-next-line react/jsx-props-no-spreading
export default memo((props) => (<AccountSettings {...props} />));
